import React from 'react'
import { Link } from 'react-router-dom';


function PresidentTile(president) {

    const formatDate = (str) => {
        if (!str) return 'Present';
        const [year, month, day] = str.split('-');
        const date = new Date(year, month - 1, day);

        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    }

    const formatName = (str) => {
        return str.replaceAll(" ", "-");
    }


    return (
        <div>
            <div className="content-card">
                <div className="content-image">
                    <img src={"/graphics/presidents/" + president.presidentialNumber + ".jpg"} />
                </div>
                <div className="content-details">
                    <div className="content-name">
                        <Link to={"/Presidents/" + president.presidentialNumber + "/" + formatName(president.name) + "?collectionIds=0"}>
                            #{president.presidentialNumber} {president.name}
                        </Link>
                    </div>
                    <h3 className="content-text">{formatDate(president.startDate)} - {formatDate(president.endDate)}</h3>
                    <div className="content-text">Executive Orders: {president.eo}</div>
                    <div className="content-text">Other Orders: {president.other}</div>
                </div>
            </div>
        </div>
    )
}

export default PresidentTile
